<template>
  <div id="spo-m">
    <a-config-provider>
      <router-view />
    </a-config-provider>
  </div>
</template>
<script>
  export default {
    name: 'App',
  }
</script>
<style lang="less">
  @import '~@/vab/styles/vab.less';
  @import './styles/base.less';
</style>
